/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Child_Age_Notice_OtherInputs */

const en_search_child_age_notice_other = /** @type {(inputs: Search_Child_Age_Notice_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick your children's ages to include them all in these results.`)
};

/**
* | output |
* | --- |
* | "Pick your children's ages to include them all in these results." |
*
* @param {Search_Child_Age_Notice_OtherInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const search_child_age_notice_other = /** @type {((inputs?: Search_Child_Age_Notice_OtherInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Child_Age_Notice_OtherInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_search_child_age_notice_other(inputs)
});